// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ControlFilledSvg from "@fishx/icons-svg/es/asn/ControlFilled";
import FishxIcon from '../components/FishxIcon';

var ControlFilled = function ControlFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ControlFilledSvg
  }));
};

ControlFilled.displayName = 'ControlFilled';
export default React.forwardRef(ControlFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ControlFilled.js
// module id = 2322
// module chunks = 0